import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import Logo from "@/components/Logo";
import { FaWhatsapp } from "react-icons/fa";

export default function PublicFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-24 bg-[#00A350] text-white">

      <div className="sqit-container py-16 grid gap-12 md:grid-cols-2 lg:grid-cols-4">

        {/* Logo */}
        <div className="lg:col-span-1">
          <Logo
            brand="bionivid"
            size="small"
          />

          <p className="mt-5 text-sm leading-7 text-white/80">
            Enterprise bioinformatics software for genomics,
            transcriptomics and multi-omics analysis with an intuitive
            graphical interface.
          </p>
        </div>

        {/* Product */}
        <div>
          <h3 className="mb-5 text-lg font-semibold">
            Product
          </h3>

          <ul className="space-y-3 text-sm text-white/80">
            <li><a href="#sqit-ai">SQIT.ai™ Software</a></li>
            <li><a href="#omics-station">Omics Station</a></li>
            <li><a href="#sqit-saas">SQIT.ai™ SaaS Model</a></li>
            <li><Link to="/modules">Modules</Link></li>
          </ul>
        </div>

        {/* Resources */}
        {/* <div>
          <h3 className="mb-5 text-lg font-semibold">
            Resources
          </h3>

          <ul className="space-y-3 text-sm text-white/80">
            <li><Link to="/documentation">Documentation</Link></li>
            <li><Link to="/workflows">Workflows</Link></li>
            <li><Link to="/tutorials">Tutorials</Link></li>
            <li><Link to="/updates">Release Notes</Link></li>
          </ul>
        </div> */}

        {/* Company */}
        <div>
          <h3 className="mb-5 text-lg font-semibold">
            Company
          </h3>

          <ul className="space-y-3 text-sm text-white/80">
            <li>
              <a href="https://bionivid.in/about-us/" target="_blank" rel="noopener noreferrer">
                About Us
              </a>
            </li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h3 className="mb-5 text-lg font-semibold">
            Contact
          </h3>

          <div className="space-y-4 text-sm text-white/80">

            <div className="flex gap-3">
              <Icons.Mail size={18} className="mt-0.5 shrink-0" />
              <span>support@sqit.online</span>
            </div>

            <div className="flex gap-3">
              <Icons.Phone size={18} className="mt-0.5 shrink-0" />
              <span>+91 953 5619 191</span>
            </div>

            <div className="flex gap-3">
              <Icons.MapPin size={18} className="mt-0.5 shrink-0" />
              <span>
                3rd Floor, Saanvi Complex, 28,
                Kattigenahalli,
                <br />
                Bengaluru, Karnataka 560064
              </span>
            </div>

            <div className="mt-5 overflow-hidden rounded-xl border border-white/10">
              <iframe
                title="SQIT Office Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3885.658660077726!2d77.62716467578893!3d13.120797211588265!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae112d7040469b%3A0x7fb9e08b6e52b348!2sBionivid%20Technology%20Private%20Limited!5e0!3m2!1sen!2sin!4v1784533387576!5m2!1sen!2sin"
                width="100%"
                height="180"
                style={{ border: 0 }}
                loading="lazy"
                allowFullScreen
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>

            <div className="flex gap-4 pt-2">

              <a
                href="https://www.linkedin.com/company/bionivid-technology"
                target="_blank"
                rel="noopener noreferrer"
                className="transition hover:text-white"
              >
                <Icons.Linkedin size={20} />
              </a>

              <a
                href="https://www.youtube.com/@bionivid_technology"
                target="_blank"
                rel="noopener noreferrer"
                className="transition hover:text-white"
              >
                <Icons.Youtube size={20} />
              </a>

              <a
                href="https://www.instagram.com/bionividtechnology"
                target="_blank"
                rel="noopener noreferrer"
                className="transition hover:text-white"
              >
                <Icons.Instagram size={20} />
              </a>

              <a
                href="https://www.facebook.com/Bionivid"
                target="_blank"
                rel="noopener noreferrer"
                className="transition hover:text-white"
              >
                <Icons.Facebook size={20} />
              </a>

              <a
                href="https://wa.me/919535619191"
                target="_blank"
                rel="noopener noreferrer"
                className="transition hover:text-white"
              >
                <FaWhatsapp size={20} />
              </a>

            </div>

          </div>
        </div>

      </div>

      <div className="border-t border-white/10">
        <div className="sqit-container flex flex-col items-center justify-between gap-4 py-6 text-sm text-white/70 md:flex-row">

          <div>
            © {year} SQIT.ai™. All rights reserved.
          </div>

          <div className="flex gap-6">
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms-of-service">Terms of Service</Link>
          </div>

        </div>
      </div>

    </footer>
  );
}